export function CollectionAnnotationBadge({ badge }: { badge: string | null }) {
  if (!badge) return null;

  return (
    <div className="mt-1.5 flex min-w-0">
      <span className="inline-flex max-w-full rounded-md bg-secondary px-2 py-1 text-[11px] font-semibold leading-tight text-secondary-foreground">
        {badge}
      </span>
    </div>
  );
}
